import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToSection = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Attendre que la page soit chargée
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Scroll to top si pas de hash
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return null;
};
